import React, { useContext, useRef } from 'react';
import classes from './PostEditorBulkImportCollapsedGroupElement.module.scss';
import { PostEditorGroupDataContext } from '../states/PostEditorGroupDataProvider';
import { PostEditorContext } from '../states/PostEditorProvider';
import { serializeTextForQueue } from '../TextEditor/helpers/serializer';
import { Loader } from '../../../components/containers/Loader';
import { CSSTransition } from 'react-transition-group';
import { MediaTypePostEditorState } from '../../../models/post-editor';
import classNames from 'classnames';

const MediaItem = (props: MediaTypePostEditorState): JSX.Element => {
  const { id, loading, thumbnailUrl } = props;
  const loaderNodeRef = useRef<HTMLDivElement>(null);
  return (
    <div className={classNames(classes.MediaItem, { [classes.MediaItemLoading]: loading })}>
      <div className={classes.ImageWrapper}>
        {thumbnailUrl ? <img src={thumbnailUrl} alt={`preview-${id}`} /> : null}
      </div>
      <CSSTransition in={loading} timeout={300} classNames={'fade'} nodeRef={loaderNodeRef} unmountOnExit>
        <div className={classes.LoadingWrapper} ref={loaderNodeRef}>
          <Loader variation={'dark'} size={'small'} />
        </div>
      </CSSTransition>
    </div>
  );
};

export const PostEditorBulkImportCollapsedGroupElementView = (): JSX.Element => {
  // we are always in shared mode if the group is collapsed. That's why we can safely take data from the group attributes and we don't care about the customized content
  const [tabsState] = useContext(PostEditorGroupDataContext);
  const { postGroupIndex } = tabsState;
  const { state } = useContext(PostEditorContext);
  const { postGroups } = state;
  const postGroup = postGroups[postGroupIndex];
  const { content } = postGroup.groupPostAttributes;
  const { texts, media } = content;
  // we also don't have any variations in this moment, so we can safely grab the first text.
  const { text } = texts[0];
  const htmlText = serializeTextForQueue(text);
  return (
    <div>
      {htmlText ? (
        <div className={classes.BlockElement}>
          <div className={classes.InlinedText} dangerouslySetInnerHTML={{ __html: htmlText }} />{' '}
        </div>
      ) : null}
      <div
        className={classNames(
          classes.BlockElement,
          classes.BlockElementMedia,
          'grid-x',
          media.length ? classes.BlockElementWithImages : undefined
        )}>
        {media.length
          ? media.map((item, index) => (
              <div
                className={classNames('cell', 'shrink', classes.BlockElementMediaWrapper)}
                key={`${index + 1}-${item.id}`}>
                <MediaItem {...item} />
              </div>
            ))
          : 'NO MEDIA ATTACHED'}
      </div>
    </div>
  );
};
